export const SCENE_BG = '#020308';
/** Bump to remount the Three scene after HMR leaves a stale graph layer. */
export const NEURAL_SCENE_REVISION = 164;
export const FOG_DENSITY = 0.0045;
export const BLOOM_STRENGTH = 0.55;
export const BLOOM_RADIUS = 0.35;
export const BLOOM_THRESHOLD = 0.66;
/** Samples along a parent-level hairline. Dense enough that the bow does not facet. */
export const EDGE_LINE_SAMPLES = 28;
/** Nested stems / returns actually bend — match the parent density. */
export const EDGE_NEST_SAMPLES = 36;
export const EDGE_LINE_WIDTH = 0.9;
export const EDGE_GLOW_WIDTH = 2.6;
/** Soft halo under each hairline. 0 disables it. */
export const EDGE_GLOW_OPACITY = 0;
/** Cluster nebulae behind the graph (real tag / group regions). */
export const SHOW_CLUSTER_HAZE = true;

export const FOCUS_ORBIT_DIST = 32;
/** Camera-to-mission distance when jumping from Active / Available lists */
export const FOCUS_HUD_ORBIT_DIST = 18;
/** Plane view: camera sits slightly above the graph plane (y per unit z) */
export const PLANE_VIEW_TILT = 0.22;
/**
 * Nested campaigns live on their own plane behind the parent graph.
 * Each nesting level drops this far in z; the tilt turns the drop into a
 * visible screen offset and pan/drift into parallax.
 */
export const NEST_Z_STEP = 4.5;
/**
 * Whisper of depth on the same nest layer. 0 = sources (toward camera),
 * 1 = sinks (away). Tiny vs NEST_Z_STEP so islands still read as one plane.
 */
export const SAME_LEVEL_Z = 0.7;
/** Per nesting level: multiplier on node glow and wire opacity so lower layers recede. */
export const NEST_DEPTH_DIM = 0.6;
/** Idle orbit: a slow circle around the current view, like a gentle left-drag. */
export const DRIFT_YAW = 0.16;
export const DRIFT_PITCH = 0.12;
export const DRIFT_SPEED = 0.22;
/** Seconds to ease idle orbit from rest back to full speed after a drag. */
export const DRIFT_RESUME_SEC = 3;
/** Camera zoom range in the plane view */
export const PLANE_MIN_DIST = 4.5;
export const PLANE_MAX_DIST = 160;
export const FOCUS_TARGET_LERP = 0.11;
export const FOCUS_CAM_LERP = 0.11;
export const FOCUS_SNAP_EPS = 0.08;
export const VIEW_SAMPLE_COUNT = 18;
export const VIEW_CONE_SPREAD = 0.32;
export const SELECTION_BRIGHTEN = 0.38;

export const STATUS_HEX = {
  completed: 0x3d9aa8,
  in_progress: 0xb7c6ff,
  not_started: 0x9b8cff,
  blocked: 0xff6b8c,
};

export const NEURAL_ACCENT_HEX = 0x7ff0da;
export const NEURAL_ACCENT_LERP = 0.28;

/** Sphere mesh detail — smoother silhouettes when the camera is close */
export const NODE_SPHERE_WIDTH_SEGMENTS = 20;
export const NODE_SPHERE_HEIGHT_SEGMENTS = 16;
/** Decision nodes: OctahedronGeometry detail (0 sharp, ≥1 subdivided / smoother) */
export const NODE_DECISION_OCTAHEDRON_DETAIL = 2;
/** Glowing halo around non-pending nodes */
export const HALO_SPHERE_WIDTH_SEGMENTS = 40;
export const HALO_SPHERE_HEIGHT_SEGMENTS = 40;
/** Selection ring: radial = samples around the tube profile, tubular = samples along the ring */
export const SELECTION_RING_RADIAL_SEGMENTS = 32;
export const SELECTION_RING_TUBULAR_SEGMENTS = 80;

/** Topology / filter transitions: node layout & fade (higher α = snappier) */
export const NEURAL_TRANS_POS_LERP = 0.1;
/** Island retag / membership jump — quick glide, not the slow settle. */
export const NEURAL_LAYOUT_JUMP_LERP = 0.34;
export const NEURAL_TRANS_FADE_LERP = 0.085;
export const NEURAL_TRANS_EDGE_FADE_LERP = 0.08;
/** World-units². Bigger than this is an island hop, not a nudge. */
export const LAYOUT_JUMP_DIST2 = 0.4;

/** How quickly a hidden satellite peeks out from behind its hub. */
export const NEST_REVEAL_LERP = 0.22;

/** Pointer hover is paint-only (emissive / name / cursor). Never world scale. */
